import { MdWarningAmber } from 'react-icons/md';

// Inline warning chip beside keys flagged as UI-coupled in their description
// (price-history chip labels, prediction horizons, month abbreviations etc.).
// Editing these without a coordinated mobile release breaks layout — the
// chip nudges admins toward the description before clicking Edit.
export function UiCoupledBadge() {
  return (
    <span
      title="UI-coupled — change with care; mobile layout assumes specific values"
      className="inline-flex items-center gap-1 rounded-full bg-warning/15 px-1.5 py-[2px] text-[9.5px] font-bold uppercase leading-none tracking-wide text-warning"
    >
      <MdWarningAmber size={10} />
      UI-coupled
    </span>
  );
}
